(function () {
  'use strict';

  // Tickets carry a _selectedDate property written by the calendar. The calendar
  // itself refuses to let a customer pick a past date, but a date already in the
  // cart can still slide into the past while it sits there. This blocks checkout
  // for any such line and asks the customer to remove it — there is nothing to
  // "fix" in place, since the same variant/date combo can't be re-selected.
  // Kept apart from cart-date-check.js (which asks the app proxy whether a
  // future date is still available) and cart-birthday-check.js (missing
  // birthday details) — this one only reads the cart, like the birthday check.

  if (!document.getElementById('cart-expired-date-check-styles')) {
    const style = document.createElement('style');
    style.id = 'cart-expired-date-check-styles';
    style.textContent = `
      .cart-expired-date-toast {
        position: fixed;
        bottom: 2rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 100001;
        width: min(92vw, 44rem);
        background: #fff;
        border: 1.5px solid #fbbf24;
        border-radius: .8rem;
        box-shadow: 0 4px 24px rgba(0,0,0,.14);
        padding: 1.4rem 1.6rem;
        animation: _cedc-up .22s ease;
        font-size: 1.4rem;
        line-height: 1.5;
      }
      @keyframes _cedc-up {
        from { opacity: 0; transform: translateX(-50%) translateY(1.2rem); }
        to   { opacity: 1; transform: translateX(-50%) translateY(0); }
      }
      .cart-expired-date-toast__header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 1rem;
        margin-bottom: 1rem;
      }
      .cart-expired-date-toast__title {
        font-weight: 700;
        font-size: 1.4rem;
        color: #92400e;
        margin: 0;
        line-height: 1.3;
      }
      .cart-expired-date-toast__close {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 1.8rem;
        line-height: 1;
        color: #92400e;
        padding: 0;
        flex-shrink: 0;
        opacity: .65;
        transition: opacity .15s;
      }
      .cart-expired-date-toast__close:hover { opacity: 1; }
      .cart-expired-date-toast__list {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: .6rem;
      }
      .cart-expired-date-toast__list li {
        padding: .7rem .9rem;
        background: #fffbeb;
        border: 1px solid #fde68a;
        border-radius: .5rem;
        color: #333;
        line-height: 1.4;
      }
      .cart-expired-date-toast__list small {
        display: block;
        margin-top: .2rem;
        color: #92400e;
        font-size: 1.2rem;
      }
      @media (max-width: 749px) {
        .cart-expired-date-toast {
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          transform: none;
          border-radius: 1.2rem 1.2rem 0 0;
          animation: _cedc-up-m .22s ease;
        }
        @keyframes _cedc-up-m {
          from { opacity: 0; transform: translateY(1.2rem); }
          to   { opacity: 1; transform: translateY(0); }
        }
      }
    `;
    document.head.appendChild(style);
  }

  const TOAST_ID = 'cart-expired-date-check-toast';

  // #packeta_checkout is rendered by another app; cart-date-check.js skips it too.
  const BTN_SELECTOR = '.delivery-button, .cart__checkout-button:not(#packeta_checkout)';

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function removeToast() {
    document.getElementById(TOAST_ID)?.remove();
  }

  function showToast(btn, titles) {
    removeToast();

    const titleText = btn.dataset.msgErrorTitle || 'Unable to proceed with order';
    const closeLabel = btn.dataset.msgClose || 'Close';
    const reason = btn.dataset.msgExpiredDate || "This ticket's date has already passed. Please remove it from your cart.";

    const toast = document.createElement('div');
    toast.id = TOAST_ID;
    toast.className = 'cart-expired-date-toast';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');

    const header = document.createElement('div');
    header.className = 'cart-expired-date-toast__header';

    const titleEl = document.createElement('p');
    titleEl.className = 'cart-expired-date-toast__title';
    titleEl.textContent = titleText;
    header.appendChild(titleEl);

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'cart-expired-date-toast__close';
    closeBtn.setAttribute('aria-label', closeLabel);
    closeBtn.textContent = '✕';
    closeBtn.addEventListener('click', removeToast);
    header.appendChild(closeBtn);

    toast.appendChild(header);

    const list = document.createElement('ul');
    list.className = 'cart-expired-date-toast__list';
    list.innerHTML = titles
      .map(title => `<li><strong>${escHtml(title)}</strong><br><small>${escHtml(reason)}</small></li>`)
      .join('');

    toast.appendChild(list);
    document.body.appendChild(toast);

    setTimeout(removeToast, 10000);
  }

  function expiredTitles(btn) {
    const raw = btn.dataset.expiredDateItems;
    if (!raw || raw === '[]') return [];
    try {
      return JSON.parse(raw);
    } catch (_) {
      return [];
    }
  }

  // Capture phase on the document, so this runs before cart-date-check's own
  // listener on the button and can stop it from firing a pointless request.
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest?.(BTN_SELECTOR);
      if (!btn) return;

      const titles = expiredTitles(btn);
      if (!titles.length) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      showToast(btn, titles);
    },
    true
  );

  // cart/add.js returns only the added line, so fall back to the items snapshot
  // that rides along in the cart-icon-bubble section.
  function itemsFromSections(sections) {
    const html = sections && sections['cart-icon-bubble'];
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const script = doc.querySelector('[data-cart-date-check-items]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (_) {
      return null;
    }
  }

  function applyCartUpdate(items) {
    const todayIso = new Date().toISOString().split('T')[0];
    const titles = [];
    items.forEach(function (item) {
      const raw = item.properties && item.properties._selectedDate;
      if (!raw) return;
      let isoDate;
      try { isoDate = new Date(raw).toISOString().split('T')[0]; } catch (_) { return; }
      if (isoDate < todayIso) titles.push(item.title);
    });

    document.querySelectorAll(BTN_SELECTOR).forEach(function (btn) {
      btn.dataset.expiredDateItems = JSON.stringify(titles);
    });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    const cartData = event && event.cartData;
    if (!cartData) return;

    const items = cartData.items || itemsFromSections(cartData.sections);
    if (items) applyCartUpdate(items);
  });
})();
